// extracted by mini-css-extract-plugin
export default {"container":"VM-z","disabled":"WM-z","bgBlack":"XM-z","content":"YM-z","countdown":"ZM-z","topCaption":"_M-z","topHeading":"aN-z","heading":"bN-z","copy":"cN-z"};